import React from 'react';
import LoadingSpinner from 'components/loading_spinner';
import './styles.scss';

export default function LoadingCard() {
  return (
    <div className="mb-4 col-md-4">
      <div className="ds-client-report-card d-flex flex-column gap-4 p-4 h-100">
        <div className="ds-client-report-value align-items-center justify-content-center d-flex py-3 px-4">
          <LoadingSpinner size="lg"/>
        </div>
        <div className="ds-client-report-text d-flex align-items-center justify-content-center flex-grow">
          Loading...
        </div>
      </div>
    </div>
  );
}
